// src/main.js
import { createApp } from "vue";
import App from "./App.vue";

// KOLEJNOŚĆ
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "@/assets/styles/global.scss";

import router from "./router";
import store from "./store";
import { registerPrimeVue } from "@/plugins/primevue";
import { initAuth } from "@/bootstrap/auth";
import Cookies from "js-cookie";
import http from "@/shared/http/http";
import { configureHttpInterceptors } from "@/shared/http/configureHttpInterceptors.mjs";
import { showToast } from "@/utils/toastService";

const app = createApp(App);

configureHttpInterceptors({ http, store, router, cookies: Cookies, showToast });

app.use(store);
app.use(router);
registerPrimeVue(app); // nie powinno ładować styli

initAuth();

app.mount("#app");
